var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg1493329265a)" },
      React.createElement("path", { d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z", fill: "#F0F0F0" }),
      React.createElement("path", { d: "M24 0C15.49 0 8.016 4.429 3.754 11.107L36.3 44.611C43.307 40.42 48 32.758 48 24 48 10.745 37.255 0 24 0z", fill: "#FFDA44" }),
      React.createElement("path", { d: "M48 24c0-6.227-2.372-11.9-6.26-16.165v32.33A23.912 23.912 0 0 0 48 24zM29.98 45.176l2.514-.002.776-2.392.778 2.391h1.26a23.982 23.982 0 0 0 2.242-1.363L4.19 10.45c-.55.803-1.052 1.64-1.502 2.508l.296.91h2.514l-2.033 1.478.778 2.39L2.21 16.26l-1.214.883A23.992 23.992 0 0 0 0 24c0 13.255 10.745 24 24 24 2.802 0 5.492-.481 7.992-1.364l-2.012-1.46zM5.353 22.956l.775-2.39-2.034-1.477 2.514-.002.775-2.392.778 2.391 2.514-.002-2.033 1.48.779 2.39-2.035-1.477-2.033 1.48zm5.177 5.218l.776-2.392-2.035-1.476 2.514-.002.775-2.391.779 2.39 2.514-.001-2.033 1.479.778 2.39-2.035-1.476-2.033 1.479zm5.178 5.217L16.483 31l-2.035-1.477 2.514-.001.776-2.392.778 2.39h2.514l-2.033 1.478.778 2.39-2.034-1.476-2.033 1.48zm7.21 3.739l-2.033 1.479.775-2.392-2.034-1.476 2.514-.002.775-2.391.778 2.39 2.514-.001-2.033 1.478.779 2.391-2.035-1.476zm3.144 6.696l.775-2.391-2.034-1.477 2.514-.002.775-2.391.779 2.39 2.514-.001-2.033 1.479.778 2.39-2.035-1.476-2.033 1.479z", fill: "#0052B4" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg1493329265a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" })
      )
    )
  );
});